{
  "similar": {
    "title": "相似拍賣"
  },
  "related": {
    "set": "同系列更多卡品",
    "character": "同角色更多卡品",
    "grade": "相同評級",
    "price": "相近價格範圍"
  },
  "forYou": {
    "title": "為您推薦"
  },
  "trending": {
    "title": "熱門卡品",
    "noPrice": "—",
    "sales": "近期 {count} 宗成交"
  },
  "recentlyViewed": {
    "title": "最近瀏覽",
    "clear": "清除"
  },
  "popularSellers": {
    "title": "人氣賣家",
    "fallbackName": "BidNova 賣家",
    "new": "新賣家",
    "sales": "{count} 宗銷售"
  }
}
